import {
  Avatar,
  Box,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  useTheme
} from "@mui/material";
import { BCPMedal } from "../../../../components/icons/bcp/BCPIcons";
import { findGetParameter } from "../../../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../../../global/environmentVariables";

export default function GroupMedalBox({
  activeTab,
  label,
  gameType,
  eventGroupId,
  groupNamePlural,
  groupData,
  hideCompleteLeaders,
  appRoute
}) {
  const theme = useTheme();

  const embed = appRoute || findGetParameter("embed");
  const _darkMode = findGetParameter("darkMode") === "true";
  const _lightMode = findGetParameter("lightMode") === "true";
  const _mode = _darkMode
    ? "&darkMode=true"
    : _lightMode
      ? "&lightMode=true"
      : "";

  return (
    <Box sx={{ mb: 1 }}>
      <TableContainer>
        <Table
          sx={{
            "& .MuiTableCell-root": {
              fontSize: "12px"
            }
          }}
        >
          <colgroup>
            <col style={{ width: "calc(100% - 150px)" }} />
            <col style={{ width: "50px" }} />
            <col style={{ width: "50px" }} />
            <col style={{ width: "50px" }} />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell align="left" padding="none">
                {label}
              </TableCell>
              <TableCell align="center" padding="none">
                <BCPMedal color={theme.palette?.gold?.main} />
              </TableCell>
              <TableCell align="center" padding="none">
                <BCPMedal color={theme.palette?.silver?.main} />
              </TableCell>
              <TableCell align="center" padding="none">
                <BCPMedal color={theme.palette?.bronze?.main} />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groupData?.length > 0 ? (
              groupData.map((group) => {
                return (
                  <TableRow
                    key={group.name}
                    sx={{
                      borderBottom: "1px solid rgba(81, 81, 81, 1)"
                    }}
                  >
                    <TableCell
                      padding="none"
                      component="th"
                      scope="row"
                      sx={{
                        width: "calc(100% - 150px)"
                      }}
                    >
                      <span
                        style={{
                          width: "25px",
                          display: "inline-block"
                        }}
                      >
                        {group.place}
                      </span>
                      {activeTab === 0 ? (
                        <Link
                          color="inherit"
                          underline="none"
                          href={`/world-championships-of-warhammer${
                            eventGroupId === "WorldChamps25"
                              ? "-25"
                              : eventGroupId === "WorldChamps24"
                                ? "-24"
                                : eventGroupId === "WorldChamps23"
                                  ? "-23"
                                  : ""
                          }/players?countryCode=${group.countryCode}${
                            embed ? `&embed=${embed}` : ""
                          }${
                            group.groupName
                              ? `&groupName=${group.groupName}`
                              : ""
                          }${_mode}${gameType ? `&gameType=${gameType}` : ""}`}
                        >
                          <Top5Row group={group} activeTab={activeTab} />
                        </Link>
                      ) : (
                        <Top5Row group={group} activeTab={activeTab} />
                      )}
                    </TableCell>

                    <TableCell padding="none" align="center">
                      {group.wcwGold}
                    </TableCell>
                    <TableCell padding="none" align="center">
                      {group.wcwSilver}
                    </TableCell>
                    <TableCell padding="none" align="center">
                      {group.wcwBronze}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <></>
            )}
          </TableBody>
          {!hideCompleteLeaders && (
            <TableFooter>
              <TableRow sx={{ borderBottom: "unset" }}>
                <TableCell
                  padding="none"
                  colSpan={2}
                  sx={{ textAlign: "center", borderBottom: "unset" }}
                >
                  <Link
                    href={`/world-championships-of-warhammer${
                      eventGroupId === "WorldChamps25"
                        ? "-25"
                        : eventGroupId === "WorldChamps24"
                          ? "-24"
                          : eventGroupId === "WorldChamps23"
                            ? "-23"
                            : ""
                    }/${groupNamePlural.toLowerCase()}?${
                      embed ? `embed=${embed}` : ""
                    }${_mode}${
                      gameType
                        ? `&gameType=${gameType}&orderBy=points${gameType}`
                        : ""
                    }`}
                  >
                    Complete Leaders
                  </Link>
                </TableCell>
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </Box>
  );
}

function Top5Row({ group, activeTab }) {
  return (
    <>
      <Box
        sx={{
          display: "inline-block",
          mr: 1,
          paddingTop: "2px"
          // display: "flex", alignItems: "center"
        }}
      >
        <Avatar
          alt={group?.name || (activeTab === 0 ? "Country" : "Player")}
          src={`${getEnvironmentVariable(
            "SYSTEM_IMAGES_CLOUDFRONT"
          )}/system-images/countries/${group.countryCode}.svg`}
          sx={{
            width: 12,
            height: 12,
            position: "relative",
            top: "2px"
          }}
        />
      </Box>
      <span
        style={{
          display: "inline-block",
          position: "relative",
          top: "4px",
          maxWidth: "calc(100% - 45px)", // 25 + 16

          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
      >
        {group.name}
      </span>
    </>
  );
}
